export const SEND_FORM_NAME = 'send';
export const REQUEST_FORM_NAME = 'request';
export const OFAKIM_FORM_NAME = 'ofakim';
export const FILTER_FORM_NAME = 'filter';
export const EMAIL_POPUP_FORM_NAME = 'emailPopup';
export const INVITE_CODE_FORM_NAME = 'inviteCodeCheck';
export const ANTIFRAUD_HRJ = 'antifraudHrj';
export const ANTIFRAUD_CVV = 'antifraudCvv';
export const ANTIFRAUD_SUM_VERIFICATION = 'antifraudSumVerification';
export const PROFILE_FORM_NAME = 'profile';
export const SMS_ON_SUCCESS_PAY_FORM_NAME = 'smsOnSuccessPay';
export const FEEDBACK_FORM_NAME = 'feedback';
export const ADD_SOURCE_BANK_ACCOUNT = 'addBankAccount';
export const ADD_SOURCE_BANK_CARD = 'addBankCard';
export const LOGIN_REGISTRATION_FORM_NAME = 'loginRegistration';
export const CHECK_BIRTHDAY_FORM_NAME = 'checkBirthday';
export const SMS_CONFIRMATION_FORM_NAME = 'smsConfirmation';
export const PASSCODE_FORM_NAME = 'passcodeForm';
export const CHANGE_PHONE_NUMBER = 'changePhoneNumber';
export const CHANGE_EMAIL = 'changeEmail';
export const PROFILE_NOTIFICATION = 'profileNotification';
export const AML_LEVEL_FORM = 'aml_level_form';
export const PROFILE_USA_OCCUPATION = 'profileUsaOccupation';
export const CONFIRM_CARD_BY_AMOUNT = 'confirmCardByAmount';
export const CONFIRM_CARD_BY_CODE = 'confirmCardByCode';
export const TOP_UP_ACCOUNT = 'topUpAccount';
export const CHANGE_PIN_FORM_NAME = 'changePin';
export const GA_SEND_FORM_NAME = 'gaSend';
export const GA_EXCHANGE_FORM_NAME = 'gaExchange';
export const GA_ACTIVITY = 'gaActivity';
export const GA_ORDER_PLASTIC_CARD_PIN = 'gaOrderPlasticCardPin';
export const GA_ORDER_PLASTIC_CARD_ADDRESS = 'gaOrderPlasticCardAddress';
export const GA_ORDER_PLASTIC_CARD_DIGITS = 'gaOrderPlasticCardDigits';
export const SUGGESTED = 'suggested';
export const ADD_REQUEST_ACQUIRING = 'addRequestAcquiring';
export const ADD_CANDIDATE = 'addCandidate';
export const FINISH_REGISTRATION = 'finishRegistration';
export const KYC_UZBEKISTAN_FORM_NAME = 'kycUzbekistan';
export const KYC_EMIRATES_FORM_NAME = 'kycEmirates';
export const PLUS_UNSUBSCRIBE_FORM_NAME = 'plusUnsubscribe';
export const PURPOSE_ACCOUNT_FORM_NAME = 'purposeOfAccount';
export const PLUS_SUBSCRIBE_FORM_NAME = 'subscribe_form';
export const PLUS_CHANGE_PLAN_FORM_NAME = 'change_plan_form';
export const FEEDBACK_CANCELLATION_REASONS = 'feedbackCancellationReasons';
export const PRECHEQUE_FORM = 'precheque_form';
export const TRANSFER_STATEMENT = 'transfer_statement';
export const NO_AUTH_LOGIN_REGISTRATION_FORM_NAME = 'noAuthLoginRegistration';
